import React, { Component } from 'react';
import GoogleMaps from '../../tools/GoogleMaps';

import FieldGroup from '../FieldGroup/FieldGroup';

class PlaceAutocompleteSearchBox extends Component {
  componentDidMount() {
    if (GoogleMaps.isLoaded()) {
      // todo: not sure if this hack fix is ok?
      this.setupAutocompleteInput(window.google);
    } else {
      GoogleMaps.onLoad(this.setupAutocompleteInput);
    }
  }

  render() {
    let {
      options,
      ...props
    } = this.props;
    return (
      <FieldGroup {...props} />
    );
  }

  setupAutocompleteInput = (google) => {
    let input = document.getElementById(this.props.id);
    let options = this.props.options;
    var ac = new google.maps.places.Autocomplete(input, options);
    ac.addListener("place_changed", () => {
      const onChange = this.props.onChange;
      if (onChange) {
        const place = ac.getPlace() || null;
        const value = place ? place.formatted_address || place.name  : "";
        let e = {
          target: {
            name: this.props.name,
            value: value,
          },
          preventDefault: () => {},
        }
        onChange(e, this.validatePlace(place));
      }
    });
  }

  validatePlace = (place) => {
    return !!(place.id && place.place_id);
  }
};

export default PlaceAutocompleteSearchBox;


// WEBPACK FOOTER //
// ./src/components/PlaceAutocomplete/SearchBox.js